import { h } from 'preact';
import FontAwesome from 'react-fontawesome';

import style from './style.scss';
import btnCallEnd from '../../../assets/btnCallEnd.png';
import btnCallStart from '../../../assets/btnCallStart.png';
import btnCancel from '../../../assets/btnCancel.png';
import btnNextPro from '../../../assets/next-pro.svg';
import btnText from '../../../assets/btnText.png';

import btnControlVideo from '../../../assets/btnControlVideo.png';
import btnControlSpeaker from '../../../assets/btnControlSpeaker.png';
import btnControlMute from '../../../assets/btnControlMute.png';
import btnControlScreenSharing from '../../../assets/btnControlScreenSharing.png';

import { chatBtns } from '../../../utils/consts';

export const Btn = ({ text, clickHandler, hideText }) => {
  let src;
  switch (text) {
    case chatBtns.cancel:
      src = btnCancel;
      break;
    case chatBtns.decline:
    case chatBtns.finish:
    case chatBtns.cancelCall:
      src = btnCallEnd;
      break;
    case chatBtns.pickUp:
      src = btnCallStart;
      break;
    case chatBtns.textMe:
      src = btnText;
      break;
    case chatBtns.next:
      src = btnNextPro;
      break;
  }

  return (
    <div className={style.btn}>
      <img className={style.btnImg} src={src} onClick={clickHandler} />
      <div className={style.btnText} onClick={clickHandler}>{hideText ? '' : text}</div>
    </div>
  );
};

export const ControlBtn = ({
  type, clickHandler, isTurnOff, isFullScreen,
}) => {
  let el;
  switch (type) {
    case chatBtns.control.mute:
      el = <img alt="" src={btnControlMute} />;
      break;
    case chatBtns.control.speaker:
      el = <img alt="" src={btnControlSpeaker} />;
      break;
    case chatBtns.control.video:
      el = <img alt="" src={btnControlVideo} />;
      break;
    case chatBtns.control.screenSharing:
      el = <img alt="" src={btnControlScreenSharing} />;
      break;
    case chatBtns.control.fullScreen:
      el = isFullScreen
        ? <FontAwesome name="compress" size="3x" />
        : <FontAwesome name="expand" size="3x" />;
      break;
  }

  return el && (
  <div className={style.controlBtn} onClick={clickHandler}>
    {el}
    { isTurnOff && <div className={style.lineThrough} />}
  </div>
  );
};



// WEBPACK FOOTER //
// ./components/communication/call-btn/index.js